import {createProductOccupancyRulePending,modifyProductOccupancyRuleFail,modifyProductOccupancyRuleSuccess,modifyProductOccupancyRulePending,getSProductOccupancyRuleFail,getSProductOccupancyRulePending,getSProductOccupancyRuleSuccess, createProductOccupancyRuleSuccess,createProductOccupancyRuleFail,getSOccupancyRulePending} from "./occupancyruleSlice";
import { productoccupancyruleCreation,fetchSingleOccupancyRule,productoccupancyruleModify } from "../../../api/userApi";



export const newProductOccupancyRuleCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createProductOccupancyRulePending());
        const result = await productoccupancyruleCreation(frmDt);
        result.status === "success"
            ? dispatch(createProductOccupancyRuleSuccess(result.message))
            : dispatch(createProductOccupancyRuleFail(result.message));

    } catch (error) {
   
        const err = JSON.parse(JSON.stringify(error.response.data.errors));

       
       const row = err.map((er, i) => {
 

       
            if (i === er.length - 1) {
              return er.param+' '+er.msg+'. ';
            }
            return er.param+' '+er.msg+' ';
          });
       
          dispatch(createProductOccupancyRuleFail(row));
     
       
       
       
    }

}

export const getSingleOccupancyRule = (id) => async (dispatch) => {
    
 
    try {
     //call the api
    dispatch(getSProductOccupancyRulePending());
    const result = await fetchSingleOccupancyRule(id);

 console.log("royalab",result);

 
 //console.log('check user profile out if');
    if(result.productoccupancyrule[0] && result.productoccupancyrule[0].id){
    //console.log('check user profile');
        return dispatch(getSProductOccupancyRuleSuccess(result.productoccupancyrule[0]));
    }
    dispatch(getSProductOccupancyRuleFail("product occupancy rule is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
   // console.log(err.msg);
    dispatch(getSProductOccupancyRuleFail(err.msg));
 
 }
    
 
 }


export const occupancyruleModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyProductOccupancyRulePending());
        const result = await productoccupancyruleModify(frmDt);
        result.status === "success"
            ? dispatch(modifyProductOccupancyRuleSuccess(result.message))
            : dispatch(modifyProductOccupancyRuleFail(result.message));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyProductOccupancyRuleFail(err.msg));
    }

}


